import React, { Component } from 'react'
import { connect } from 'react-redux'
import Footer from '../components/common/Footer'

export class HomePage extends Component {
    render() {
        return (
            <div className="desktop">
                {/* <h1>HOME PAGE</h1> */}
                <div style={{marginTop: '30%', width: '100%'}}>
                    <Footer />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { selectedFeatureId } = state.common.sideNav;
    return { selectedFeatureId };
}

export default connect(mapStateToProps, {})(HomePage);
